import { Checkbox, Input } from 'element-ui';
import { Switch as LSwitch } from '@/components/index';
import ResourceSvc from '@/services/resource.svc.js';
const request = new ResourceSvc();
import TableData from '@/components/user/race-events/race-calendar-widget/table/table.vue';
import { Pagination as LPagination } from '@/components/index';

export default {
    name: 'RaceCalendarWidget',
    components: {
        'table-data': TableData,
        LPagination, [Checkbox.name]: Checkbox,
        [Input.name]: Input
    },
    watch: {
        filter: {
            deep: true,
            handler(newVal, oldVal) {
                if (JSON.stringify(newVal) == JSON.stringify(oldVal)) {
                    return;
                }
                if (!oldVal) {
                    this.init();
                }
                else {
                    this.load();
                }
            }
        },
    },
    data() {
        return {
            isProcessing: false,
            currentRaceId: null,
            tableData: [],
            cardData: [],
            supportData: [],
            filter: {
                championshipType: null,
                competitionSerieType: null,
                distances: null,
                genders: null,
                openWaterType: null,
                raceAgeGroup: null,
                swimType: null,
                typesBySport: null,
                counties: null,
                searchQuery: null,
                eventDateRange: null,
                inclusive: null,
                womenOnlyWave: null,
                options: { skip: 0, take: 5, perPage: 5, page: 1 }
            },
            championshipType: [],
            competitionSerieType: [],
            distances: [],
            genders: [],
            openWaterType: [],
            raceAgeGroup: [],
            swimType: [],
            typesBySport: [],
            counties: [],
            searchQuery: '',
            eventDateRange: '',
            inclusive: [],
            womenOnlyWave: [],
            total: 0,
            page: 1,
            from: 0,
            to: 5,

            isExport: false,
            filterRaceId: null,
            isSwitherExportOne: false,
            isCardVisible: false
        }
    },
    computed: {
        isNeedSupportData() {
            return !this.filter.typesBySport &&
                !this.filter.distances &&
                !this.filter.genders &&
                !this.filter.openWaterType &&
                !this.filter.raceAgeGroup &&
                !this.filter.swimType &&
                !this.filter.counties &&
                !this.filter.searchQuery &&
                !this.filter.eventDateRange &&
                !this.filter.inclusive &&
                !this.filter.competitionSerieType &&
                !this.filter.womenOnlyWave;
        },
    },
    methods: {
        onMapClick: function (attr) {
            let filter = this.filter;
            let county = [];

            if (!filter.counties) {
                county.push(attr.mapTitle);
                filter.counties = county;
            }
            else {
                const index = filter.counties.indexOf(attr.mapTitle);
                if (index > -1) {
                    filter.counties.splice(index, 1);
                }
                else {
                    filter.counties.push(attr.mapTitle);
                }
            }
            filter.options.page = 1;
            this.load();
        },
        getFilter() {
            let filter = this.filter;
            filter.options.skip = this.skip;
            filter.options.take = this.take;
            filter.isNeedSupportData = this.isNeedSupportData;
            filter.isExport = true;
            return filter;
        },
        init() {
            this.load();
        },
        searchForRaces() {
            let filter = this.filter;
            filter.searchQuery = this.searchQuery;
            filter.options.page = 1;
            this.load();
        },
        load() {
            const self = this;
            if (self.isProcessing) {
                return;
            }
            let filter = self.getFilter();
            self.isProcessing = true;
            request.raceCalendarList(filter)
                .then(res => {
                    if (res && res.body && res.body.isSuccess) {
                        self.tableData = res.body.outputData.raceTableData;
                        self.total = res.body.outputData.total;
                        if (self.isNeedSupportData) {
                            self.championshipType = res.body.outputData.supportData.championshipType;
                            self.competitionSerieType = res.body.outputData.supportData.competitionSerieType;
                            self.distances = res.body.outputData.supportData.distance;
                            self.genders = res.body.outputData.supportData.genders;
                            self.openWaterType = res.body.outputData.supportData.openWaterType;
                            self.raceAgeGroup = res.body.outputData.supportData.raceAgeGroup;
                            self.swimType = res.body.outputData.supportData.swimType;
                            self.counties = res.body.outputData.supportData.counties;
                            self.typesBySport = res.body.outputData.supportData.typesBySport;
                        }
                        self.isProcessing = false;
                    }
                    else {
                        self.$showError(res && res.body && res.body.message ? res.body.message : null, 5000);
                    }
                },
                    err => {
                        self.isProcessing = false;
                        self.$showError(5000);
                    });
        },
        loadRaceCard(raceId) {
            let self = this;
            if (raceId && raceId != null) {

                if (self.isProcessing) {
                    return;
                }

                self.isProcessing = true;
                request.raceCalendarCardInfo(raceId)
                    .then(res => {
                        if (res && res.body && res.body.isSuccess) {
                            self.cardData = res.body.outputData[0];
                            self.isProcessing = false;
                            self.isCardVisible = true;
                        }
                        else {
                            self.$showError(res && res.body && res.body.message ? res.body.message : null, 5000);
                        }
                    },
                        err => {
                            self.isProcessing = false;
                            self.$showError(5000);
                        });
            }
        },
    },
    mounted() {
        this.init();
    },
    beforeCreate() {
        const css = `#launcher {
    display: none !important;
}
    `;
        this.styleTag = document.createElement('style');
        this.styleTag.appendChild(document.createTextNode(css));
        document.head.appendChild(this.styleTag);

    },
    destroyed() {
        this.styleTag.remove();
    }
};



// WEBPACK FOOTER //
// ./src/components/user/race-events/race-calendar-widget/layout/layout.js